import { JsonProperty } from "@outfoxx/jackson-js";

export class Executor {
    @JsonProperty()
    id: number;
    @JsonProperty()
    name: string;
    @JsonProperty()
    type: string;
}